<template>
  <div class="article-list">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>城市群管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <div>
        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          size="small"
          v-model="key"
        ></el-input>
      </div>
      <div> <el-button type="primary" size="small" @click.native="Query">查询</el-button></div>
      <div class="add"> <el-button type="primary" size="small" @click="goTo('/city-group-add')">+ 添加城市群二维码</el-button></div>
    </div>
    <div class="list">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        size="small"
      >
        <el-table-column
          prop="province"
          label="城市群名称">
        </el-table-column>
        <el-table-column
          prop="c_time"
          label="上传时间">
        </el-table-column>
        <el-table-column label="显示的图片">
          <template slot-scope="scope">
            <img v-if="scope.row.qrcodeRUL" :src="scope.row.qrcodeRUL" class="table-image" alt="Uploaded Image">
            <el-button v-else @click="handleEditImage(scope.row)">上传图片</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作">

          <template slot-scope="scope">
            <div class="upload-container">
              <el-button type="danger"  size="small" @click="deleteArticle(scope.row.id)">删除</el-button>
              <button class="upload-button" @click="uploadQRCode(scope.row)">点击上传二维码</button>
              <input
                id="file-input"
                type="file"
                accept="image/png, image/jpeg"
                style="display: none;"
                ref="fileInput"
                @change="handleEditImage"
              />
            </div>
<!--            <el-button  @click="handleEditImage(scope.row)">修改图片</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>


<script>
import axios from "axios";

export default {
  data() {
    return {
      pages:1,
      limit: 10,
      key: '',
      tableData: [],
      total:0,
      clickBool:false,
      setRow:null
    }
  },
  methods: {
    // + this.pages + '&limit=' + this.limit+ '&key=' + this.key,
    getList(){
      this.$get('v1/admin/province-group-qrcode', {})
        .then((res) => {
          console.log(res,'ressss')
          if (res.data.status === 'success') {

            this.tableData = res.data.data.data;

            this.total = res.data.data.total;
          } else {
            this.$msg(res.data.msg)
          }
        });
    },
    Query(){
      this.pages = 1;
      this.getList();
    },
    uploadQRCode(row){
      if(this.clickBool){
        this.$message('正在上传请稍等')
        return
      }
   this.setRow=row
      this.$refs.fileInput.click();
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex %2 === 1) {
        return '';
      } else {
        return 'success-row';
      }
    },
    handleSizeChange(val) {
      this.limit = val;
      this.getList()
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pages = val;
      this.getList()
      console.log(`当前页: ${val}`);
    },
    deleteArticle(id){
      this.$confirm('确定删除当前城市群？', () => {
        this.$delete('/v1/admin/province-group-qrcode', {id: id})
          .then((res) => {
            if (res.data.status === 'success') {
              this.getList();
            } else {
              this.$msg(res.data.msg)
            }
          });
      })
    },
    goTo(path,id){
      this.$router.push({
        path:path,
        query:{
          id:id
        }
      })
    },
    isValidImageType(file) {
      const allowedTypes = ['image/png', 'image/jpeg'];
      return allowedTypes.includes(file.type);
    },
    isValidImageSize(file) {
      const maxSize = 500 * 1024; // 500KB
      return file.size <= maxSize;
    },

    handleEditImage(event){
      if(this.clickBool){
        this.$message('正在上传请稍等')
        return
      }
      const file = event.target.files[0];
      if (file) {
        if (!this.isValidImageType(file)) {
          this.$message.error('只允许上传PNG和JPEG格式的图片');
          return;
        }
        if (!this.isValidImageSize(file)) {
          this.$message.error('图片大小超过限制');
          return;
        }
        this.selectedFile = file;
        this.previewImage = URL.createObjectURL(file)
      }
      this.clickBool=true
      const formData = new FormData();
      formData.append('qrcodeRUL', this.selectedFile);
      formData.append('province',this.setRow.province);
      formData.append('id',this.setRow.id);
      // 创建XMLHttpRequest对象

      axios.post('/v1/admin/province-group-qrcode', formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // 设置请求头为multipart/form-data
        },
      })
        .then((response) => {
          // 请求成功处理逻辑
          this.clickBool=false;
          this.selectedFile=null;
          this.setRow.qrcodeRUL=URL.createObjectURL(file);
          this.selectedOptions=[]

          this.$message.success('上传成功')
          // this.goOff()
        })
        .catch((error) => {
          // 请求失败处理逻辑
          console.log(error)
            if(!error){
              // this.$message.error('上传失败')
            }

        });

    }
  },
  created() {
    this.getList()
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.article-list
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .search
    margin 20px 0
    display flex
    justify-content flex-start
    input
      width 250px
      margin-right 20px
    .add
      padding-left 100px

  .list
    min-height 550px
    border 1px solid #EBEEF5
    .edit_icon
      width 20px
      height 20px
      margin-left 16px
      border 1px solid  #ccc
      border-radius 4px

  .block
    margin-top: 10px;
.upload {
  display: inline-block;
  margin-bottom: 20px;
}
.table-image {
  width: 100px;
  height: 100px;
}
.upload-qrcode {
  display: flex;
  flex-direction: column;
  align-items: center;

}
.upload-container {
  margin-bottom: 20px;
}
.upload-button {
  padding: 5.5px 10px
  background-color: #409eff;
  color: #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/CityManage/CityLookAndRevise.vue